import Theme from 'Theme';
import styled, { keyframes } from 'styled-components';
import Card from 'components/Card';
import config from 'config';

const baseName = config.site.baseName;

export const Header = styled.div`
  display: flex;
  align-items: center;
  padding: 24px;
  padding-bottom: 0px;
`;

export const HeaderTitle = styled.h1`
  margin: 0px;
  font-size: 28px;
  font-weight: 400;
  color: ${Theme.successColor}
  font-family: ${Theme.primaryFont};
`;

export const HeaderStep = styled.div`
  font-size: 16px;
  margin-top: 8px;
  font-family: sans-serif;
  color: ${props => props.theme.primaryColor};
`;

export const Text = styled.div`
  font-size: 14px;
  font-family: ${Theme.primaryFont};
`;

export const RegisterContainer = styled.div`
  width: 100%;
  display: flex;
  margin-top: 64px;
  align-items: center;
  justify-content: center;
`;

export const BackContain = styled.div`
  margin-top: 8px;
  margin-bottom: 16px;
`;

export const DetailsContain = styled.div``;

export const registerCardStyle = {
  innerStyle: { padding: '16px' }
};

export const FormCardContain = styled.div`
  padding: 24px;
`;

export const Link = styled.a`
  font-family: 'Roboto';
  color: ${props => props.theme.brandColor}
`;


export const LinkContain = styled.div`
  padding: 16px;
  padding-bottom: 0px;
  color: ${props => props.theme.mediumGrey};
  text-align: right;
  font-family: 'Roboto';
`;

// Logo

const zoomInRotate = keyframes`
  0% {
    opacity: 0;
    transform: scale(0, 0) rotate(0deg); 
  }
  80% {
    transform: scale(1.1, 1.1) rotate(360deg); 
  }
  100% {
    transform: scale(1.0, 1.0) rotate(360deg); 
  }
`;

const fadeInBounce = keyframes`
  0% {
    transform: translateX(20px); 
    opacity: 0;
  }
  60% {
    transform: translateX(-5px); 
  }
  100% {
    transform: translateX(0px); 
    opacity: 1;
  }
`;

const fadeIn = keyframes`
  0% {
    transform: translateX(20px); 
    opacity: 0;
  }
  100% {
    transform: translateX(0px); 
    opacity: 1;
  }
`;

export const SearchLightLogo = styled.img`
  max-height: 50px;

  animation-delay: 0.2s;
  animation-duration: 0.5s;
  transform: scale(0, 0);
  animation-name: ${zoomInRotate};
  animation-fill-mode: forwards;
  animation-timing-function:  ease-out;
`;

SearchLightLogo.defaultProps = {
  src: `${baseName ? '/' : ''}${baseName}/img/logo.png`
};

export const SearchLightText = styled.img`
  max-height: 70px;
  transform: translateX(50px); 

  opacity: 0;
  margin-left: 16px;
  animation-delay: 0.2s;
  animation-duration: 0.5s;
  animation-name: ${fadeInBounce};
  animation-fill-mode: forwards;
  animation-timing-function:  ease-out;
`;


SearchLightText.defaultProps = {
  src: `${baseName ? '/' : ''}${baseName}/img/searchlight.png`
};


export const ContentContain = styled.div`
  padding: 24px;
`;

export const StyledCard = styled(Card)`
  position: relative;
  overflow: hidden;
  border-radius: 4px !important;

  max-width: 540px;
  animation-duration: 0.4s;
  animation-name: ${fadeInBounce};
  animation-fill-mode: forwards;
  animation-timing-function:  ease;
`;

export const Divider = styled.div`
  height: 1px;
  background-color: rgba(238,238,238 ,1);
  margin-bottom: 8px;
`;

export const TextContain = styled.div`
  flex: 1;
  display: flex;
  margin-bottom: 8px;
  background-color: #fff;
`;

export const TextInput = styled.input`
  border: 0px;
  width: 100%;
  padding-top: 8px;
  padding-left: 16px;
  padding-bottom: 8px;
  background-color: rgba(245,245,245 ,1);
  border-radius: 2px;
  height: 30px;
`;

export const ButtonContain = styled.div`
  padding-bottom: 24px;
  padding-top: 8px;
`;

export const FadeInContainer = styled.div`
  opacity: 0;

  animation-delay: 0.1s;
  animation-duration: 0.3s;
  animation-name: ${fadeIn};
  animation-fill-mode: forwards;
  animation-timing-function:  ease-out;
`;

export const FlexContainer = styled.div`
  display: flex;
  align-items: center;
  flex-direction: row;
`;

export const FlexItem = styled.div`
  flex: 1;
  position: relative
`;

export const LoadingFill = styled.div`
  height: 100%;
  width: 100%;
  transition: all 0.3s ease-in-out;
  transform-origin: center left;
  transform: scale(${({ progress = 0 }) => progress / 100}, 1);
  background-color: rgb(109, 200, 255);
`;

export const LoadingContain = styled.div`
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: center;
`;

export const PaddingBottom = styled.div`
  padding-bottom: 24px;
`;

export const MarginBottom = styled.div`
  margin-bottom: 8px
`;

export const MarginTop = styled.div`
  margin-top: 32px;
`;

export const SuccessText = styled.div`
  font-family: 'Roboto';
  line-height: 1.5em;
  color: #333;
`;

export const SuccessContain = styled.div`
`;

export const AccountName = styled.h2`
  font-size: 1.5em;
  font-weight: 400;
  color: #0c3d63;
`;


export const AddressText = styled.p`
  
`;

export const AccountContain = styled.div`
  background-color: #f5f6f7;
  text-align: center;
  padding: 0.5em;
  margin: 1em 0em;
  border-radius: 4px;
  box-shadow: inset 0px 0px 0px 1px #efefef;
`;

export const ErrorNotice = styled.div`
  font-size: 0.875em;
  padding: 0.8em;
  margin-bottom: 1em;
  background-color: #f443360f;
  box-shadow: 0px 0px 0px 1px #e2a7a370;
  line-height: 1.5em;
  color: #9a2820;
  border-radius: 4px;
`;
